import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import "../../assets/libs/node-waves/waves.min.css";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineSms } from "react-icons/md";
import { AiOutlineMail } from "react-icons/ai";
import { BiMessageDetail } from "react-icons/bi";
import { LuCalendarDays } from "react-icons/lu";
import axios from "axios";
import Spinner from "../../components/Spinner/spinner";
import Cookies from "js-cookie";
import api from "../../api";



const columns = (languageData, cookieLang) => [
  {
    name: languageData.consultations.table.type,
    sortable: true,
    cell: (row) => {
      let icon, label;

      switch (row.notification.type) {
        case "call":
          icon = <MdOutlinePhone />;
          label = languageData.consultations.communication.type.phone
          break;
        case "credit":
          icon = <MdOutlineSms />;
          label = languageData.consultations.communication.type.credit;
          break;
        case "email":
          icon = <AiOutlineMail />;
          label = languageData.consultations.communication.type.email
          break;
        case "chat":
          icon = <BiMessageDetail />;
          label = languageData.consultations.communication.type.chat
          break;
           case "sms":
          icon = <AiOutlineMail />;
          label = languageData.consultations.communication.type.sms
          break;
        default:
          label = languageData.consultations.communication.type.Unknown
          break;
      }

      return (
        <span
          className="flex align-items-center gap-5p"
       
        >
          {icon} {label}
        </span>
      );
    },
  },

  {
    name: languageData.appointments.table.expert,
    selector: (row) => (row) => row.expert.nickname,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center fw-semibold">
        <span className="avatar avatar-sm me-2 avatar-rounded">
          <a href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${row.expert.id}`}>
            <img src={(row.expert.image)} alt={row.expert.nickname}  />
        </a>
        </span>
        <a className="inherit text-none" href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${row.expert.id}`} data-interaction="expert_image" data-expert={`${row.expert.id}`}
        >
          {row.expert.nickname}
        </a>
      </div>
    ),
  },

  {
    name: languageData.appointments.table.status,
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => {
      let badgeClass;
      let badgeText;

      if (row.status === "In progress") {
        badgeClass = "badge bg-warning";
        badgeText = languageData.appointments.status.in_progress;
      } else if (row.status === "Completed") {
        badgeClass = "badge badge-grey";
        badgeText = languageData.appointments.status.finished;
      } else if (row.status === "canceled") {
        badgeClass = "badge bg-danger";
        badgeText = languageData.appointments.status.canceled;
      } else {
        badgeClass = "badge bg-success";
        badgeText = languageData.appointments.status.scheduled;
      }

      return <span className={badgeClass}>{badgeText}</span>;
    },
  },

  {
    name: languageData.consultations.table.date,
    selector: (row) => row.date.toString(),
    sortable: true,
   cell: (row) => {
  const dateTime = new Date(row.date);

  let formattedDate;

  if (cookieLang === "en") {
    const year = dateTime.getUTCFullYear();
    const month = String(dateTime.getUTCMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getUTCDate()).padStart(2, "0");
    const hours = String(dateTime.getUTCHours()).padStart(2, "0");
    const minutes = String(dateTime.getUTCMinutes()).padStart(2, "0");

    formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
  } else {
    formattedDate = new Intl.DateTimeFormat("fr-FR", {
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(dateTime);
  }

  return <span>{formattedDate}</span>;
}
  },
];

const customStyles = {
  table: {
    style: {
      border: "1px solid #dee2e6",
    },
  },
  headRow: {
    style: {
      background: "#edeef1",
      fontWeight: "400",
      textAlign: "center",
      fontSize: "13px",
    },
  },
  cells: {
    style: {
      textAlign: "center",
    },
  },
};

const Appointments = ({dataAppoint, setDataAppoint}) => {
  const [languageData, setLanguageData] = useState(null);
  const [searchText, setSearchText] = useState("");
      const defaultLang = process.env.REACT_APP_LANG;
  const [cookieLang, setCookieLang] = useState(defaultLang);
  const [showSpinner, setShowSpinner] = useState(false);


  const fetchData = async () => {
    try {
       setShowSpinner(true);
       const response = await api.get(
      `/services/appointments/list` );
 
      const resp = {
        ok: true,
        status: 200,
        data: response.data
      };


      if (!resp.ok) {
        throw new Error(resp.status);
      }

      const res = {
       total: resp.data.data.length,
      data: resp.data.data
      };
      setDataAppoint(res);
    } catch (error) {
    } finally {
       setShowSpinner(false);
    }
  };



  useEffect(() => {
       const defaultLang = process.env.REACT_APP_LANG;
 const lang = localStorage.getItem("lang") ||
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("lang="))
    ?.split("=")[1] ||
 defaultLang;

    if (lang) {
      setCookieLang(lang);
      import(`../../lang/consultations/${lang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
    fetchData()
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const filteredData = dataAppoint?.data?.filter((row) =>
    row.expert.nickname.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div
      className="tab-pane text-muted border-0 p-0 active show"
      id="home-header"
      role="tabpanel"
    >
      <div
        id="datatable-basic_wrapper"
        className="dataTables_wrapper dt-bootstrap5 no-footer"
      >
        {filteredData.length !== 0  && (
          <div className="row mb-3 w-100" >
          <div className="col-12 d-flex justify-content-end pe-3">
            <label className="d-inline-flex align-items-center">
              <input
                type="search"
                name="search"
                className="form-control form-control-sm"
                placeholder={languageData.consultations.search}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </label>
          </div>
        </div>
        )}
        
        {showSpinner ? (
  <Spinner />
) : filteredData.length === 0 ? (
          <div
            className="no-results d-flex flex-column justify-content-center align-items-center text-center"

          >
            <LuCalendarDays className="fs-40 grey" />
            <div>
              <h3 className="text-muted fw-600 fs-25">
                {languageData.appointments.no_appoint}
              </h3>
              <p className="text-muted">{languageData.appointments.find}</p>
            </div>
          </div>
        ) : (
          <DataTable
            columns={columns(languageData, cookieLang)}
            data={filteredData}
            customStyles={customStyles}
            pagination
            paginationComponentOptions={{
              rowsPerPageText: languageData.consultations.table.row,
              rangeSeparatorText: "of",
            }}
            highlightOnHover
            pointerOnHover
            sortServer
            defaultSortField="id"
          />
        )}
      </div>
    </div>
  );
};

export default Appointments;
